import { NO_VALUE } from '@pipes';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DiverterValve } from '@vi-iot/client/index';
import { DIVERTER_VALVE_VALUES } from '../translations';

@Pipe({
  name: 'diverterValvePipe',
  standalone: true,
})
export class DiverterValvePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: string): string {
    const values = Object.values(DiverterValve);
    if (!value || !values.includes(value as DiverterValve)) {
      return NO_VALUE;
    }

    const translatedValue = this.translateService.instant(DIVERTER_VALVE_VALUES[value]);

    return translatedValue || NO_VALUE;
  }
}
